export default "__VITE_ASSET__239daca0__"